(function () {
  function togglePanel(btn) {
    var panelId = btn.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    var isOpen = btn.getAttribute('aria-expanded') === 'true';

    var onEnd = function (handler) {
      panel.addEventListener('transitionend', function fn(e) {
        if (e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', fn);
        handler();
      });
    };

    if (isOpen) {
      panel.style.height = panel.scrollHeight + 'px';
      // force reflow so the browser registers the starting height
      // eslint-disable-next-line no-unused-expressions
      panel.offsetHeight;
      panel.style.height = '0px';
      onEnd(function () {
        panel.hidden = true;
        panel.style.height = '';
      });
      btn.setAttribute('aria-expanded', 'false');
    } else {
      panel.hidden = false;
      panel.style.height = '0px';
      // force reflow
      // eslint-disable-next-line no-unused-expressions
      panel.offsetHeight;
      panel.style.height = panel.scrollHeight + 'px';
      onEnd(function () {
        panel.style.height = '';
      });
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  function init(section) {
    var triggers = section.querySelectorAll('.faqs__trigger');
    triggers.forEach(function (btn) {
      if (btn.dataset.faqsBound === '1') return;
      btn.dataset.faqsBound = '1';
      btn.addEventListener('click', function () { togglePanel(btn); });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="faqs"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-section-type="faqs"]');
    if (sec) init(sec);
  });
})();
